"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('processGetGroupInfoResult')(function processGetGroupInfoResult(personaTypeSet, responseMessage) {
    if (responseMessage.Members) {
        responseMessage.Members.forEach(function (result) {
            personaTypeSet.push({
                EmailAddress: result.EmailAddress,
                PersonaId: result.PersonaId,
                ADObjectId: result.ADObjectId,
            });
        });
    }
});
//# sourceMappingURL=processGetGroupInfoResult.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/processGetGroupInfoResult.js
// module id = 3182
// module chunks = 2 3